import { render, staticRenderFns } from "./maintenance.vue?vue&type=template&id=5c08822e&"
import script from "./maintenance.vue?vue&type=script&lang=js&"
export * from "./maintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c08822e')) {
      api.createRecord('5c08822e', component.options)
    } else {
      api.reload('5c08822e', component.options)
    }
    module.hot.accept("./maintenance.vue?vue&type=template&id=5c08822e&", function () {
      api.rerender('5c08822e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/errors/maintenance.vue"
export default component.exports